import React from 'react';
import AppLayout from '../../components/AppLayout';
import OverviewList from '../../components/OverviewList';
import {PageMenu,DeleteListItem,GenerateSpreadsheet,AddListItem,
        Segment,LoadGraphic,Step,DynamicListArea,BulkEdit} from '../../components/Common';
import {Input,Button,Area} from '../../components/Input';
import u from '../../utilities/Utilities';
import moment from 'moment';

export default class InventoryItemList extends React.Component{
    r={};

    settings={
        /**** Page Setup ****/
        title:"Inventory Item",
        permission:"inventory",  //Accepts combined permission module as well
        //combinedField:"price",     //Used when permission exists in a combined field
        url:"/inventory-item-list",

        /**** Action Setup ****/
        addType:1,
        addURL:"/api/add-inventory-item-entry",
        //templateURL:"/api/get-add-tenant-template",
        //bulkURL:"/api/add-bulk-tenants",
        deleteURL:"/api/delete-inventory-item-entries",
        spreadsheetURL:"/api/generate-inventory-item-spreadsheet",
        overviewURL:"/api/get-all-inventory-item-entries",

        /**** List Setup ****/
        list:true,
        listLabel:"inventory-item-list",
        orderByField:"createdOn",
        orderByType:"descending",
        numRows:20,
        checkboxPermissions:{},
        overview:undefined,
        layout:()=>{return this.r['layout']},
        onPopup:(e)=>{this.r['layout'].onPopup(e)},
        onCancelPopup:(e)=>{this.r['layout'].onCancelPopup(e)}
    };

    pageComponents={
        //add:{component:AddExitRequestEntry,props:{}},
        delete:{component:DeleteListItem,props:{}},
        spreadsheet:{component:GenerateSpreadsheet,props:{}},
        bulkEdit:{component:BulkEdit,props:{}},
    };

    state={
        selected:{
            tags:[],
            all:false,
            data:[],
            entryCount:0
        },
        pageMenuButtons:[],
        permissions:{},
        options:{},
    };

    componentDidMount=()=>{
        const permissions = u.getPermissions(this.settings.permission);
        const bulkEditOptions = u.getBulkEdit(this.settings.listLabel);
        const bulkEditEnabled = (bulkEditOptions.length > 0 && (permissions.update));
        this.setState({
            pageMenuButtons:[
                //{label:"Add Entry",ref:"add",image:"/images/page-menu/add.png",title:"Add new entry",enabled:(permissions.create)},
                {label:"Delete Entries",ref:"delete",enabled:(permissions.delete)},
                {label:"Generate Spreadsheet",ref:"spreadsheet",enabled:true},
                {label:"Bulk Edit",ref:"bulkEdit",enabled:bulkEditEnabled,padding:"3px"},
            ],
            permissions:permissions,
        });
    }

    onSelectChange=(selected)=>{
        this.setState({selected:selected});
    }

    render=()=>{
        return (
            <AppLayout ref={(ref)=>{this.r["layout"]=ref}} settings={this.settings}>
                <div className="page-error-container">
                    <div className="page-error">{this.state.error}</div>
                </div>

                <PageMenu buttons={this.state.pageMenuButtons}
                          settings={this.settings}
                          components={this.pageComponents}
                          selected={this.state.selected}
                          />

                <OverviewList ref={(ref)=>{this.settings.overview=ref}}
                              settings={this.settings}
                              onSelectChange={this.onSelectChange}
                              registerReference={this.registerReference}
                              onMutatedChange={this.onMutatedChange}
                              location={this.props.location}>
                    {
                        (content,index,onChange,onContentChange,registerRef)=>{
                            return (
                                <ListItem key={index}
                                              index={index}
                                              content={content}
                                              onChange={onChange}
                                              onContentChange={onContentChange}
                                              registerReference={registerRef}
                                              options={this.state.options}
                                              settings={this.settings}
                                              />
                            )
                        }
                    }
                </OverviewList>
            </AppLayout>
        )
    }
}

class ListItem extends React.Component{

    state={
        step:"view",
        error:"",
        loading:false,
        loadText:"",
    };

    render=()=>{
        const {content,options,settings,onChange} = this.props;

        return (
            <div>
                <LoadGraphic active={this.state.loading} text={this.state.loadText}/>
                <div className="list-segment-error">{this.state.error}</div>
                <Step active={this.state.step == "view"}>
                    <DynamicListArea content={content}
                                     onChange={onChange}
                                     index={this.props.index}
                                     listLabel={settings.listLabel}
                                     permission={settings.permission}
                                     />
                </Step>
            </div>
        )
    }

}
